import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Icon,
  Table,
  TableContainer,
  Text,
  Thead,
  Tbody,
  Tr as ChakraTr,
  Th,
  Td as ChakraTd,
  useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import * as T from '../../../../../../components/Table'
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai'
import { Button } from '../../../../../../components/Button'
import { CustomTooltip } from '../../../../../../components/CustomTooltip'

export function HistoricoPagamento({ listHistoryPayment }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()

  const mostRecentPayment = listHistoryPayment?.reduce((prev, current) => {
    const datePrev = new Date(prev.original_data_negociacao)
    const dateCurrent = new Date(current.original_data_negociacao)
    return datePrev > dateCurrent ? prev : current
  }, {})

  const conditionColorPaymentObjectLiteral = {
    true: '#FF0000',
    false: '#378BBF',
  }

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" onClick={onOpen} cursor="pointer" pointerEvents={'auto'}>
        <Text>
          Histórico pagamento:{' '}
          <Text as="strong" color={conditionColorPaymentObjectLiteral[mostRecentPayment?.atrasado]}>
            {mostRecentPayment?.condicao_pagamento}
          </Text>
        </Text>
        <Icon as={AiFillPlusCircle} color="#378BBF" fontSize="20px" />
      </Flex>
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
            Histórico de Pagamento
          </DrawerHeader>

          <DrawerBody w="100%" mx="auto" display="flex" flexDir="column" alignItems="center" gap={10}>
            <T.Table borderCollapse="collapse">
              <T.Thead>
                <T.Th w="100px">Data</T.Th>
                <T.Th w="150px">Pedido</T.Th>
                <T.Th w="500px">Consultor</T.Th>
                <T.Th w="500px">Empresa</T.Th>
                <T.Th w="150px">Valor</T.Th>
                <T.Th w="150px">Data pagamento</T.Th>
                <T.Th w="150px">Cond. Pagamento</T.Th>
                <T.Th w="100px">Atraso</T.Th>
              </T.Thead>

              <T.Tbody>
                {listHistoryPayment.map((item, index) => (
                  <T.Tr key={index}>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.data_negociacao}
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      <Flex flexDirection="column" alignItems="center" w="100%">
                        <Text as="a" href={item.link_pdf} target="_blank" textDecor="underline" color="#378BBF">
                          {item.numero_pedido}
                        </Text>
                        <CustomTooltip
                          label={
                            <Box
                              h="16px"
                              px={2}
                              bgColor="#378BBF"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              fontSize="12px"
                              color="white"
                            >
                              {item?.info_itens?.length} itens
                            </Box>
                          }
                          bg="#fff"
                          color="black"
                          fontSize="12px"
                        >
                          <TableContainer>
                            <Table size="sm">
                              <Thead>
                                <ChakraTr>
                                  <Th>Cod</Th>
                                  <Th>Cor</Th>
                                  <Th isNumeric>Qtd</Th>
                                </ChakraTr>
                              </Thead>
                              <Tbody>
                                {item?.info_itens?.map((item, index) => (
                                  <ChakraTr bgColor="white!important" fontSize="12px" fontWeight="normal" key={index}>
                                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                                      {item.codigo_produto}
                                    </ChakraTd>
                                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                                      {item.nome_cor}
                                    </ChakraTd>
                                    <ChakraTd bgColor="white!important" fontSize="12px" fontWeight="normal">
                                      {item.quantidade_itens}
                                    </ChakraTd>
                                  </ChakraTr>
                                ))}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </CustomTooltip>
                      </Flex>
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.consultor}
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.empresa}
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.valor_nota}
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.data_pagamento}
                    </T.Td>
                    <T.Td p={1} borderRight="1px solid #cfcfcf!important">
                      {item.condicao_pagamento}
                    </T.Td>
                    <T.Td p={1}>{item.dias_atraso}</T.Td>
                  </T.Tr>
                ))}
              </T.Tbody>
            </T.Table>
          </DrawerBody>

          <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
            <Flex alignItems="center" justifyContent="end" w="100%">
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                onClick={onClose}
              >
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
